export default [
  { text: "Клієнт", value: "client", type: "text", style: "min-width: 100px" },
  {
    text: "Попередні Сплати",
    value: "prevPayments",
    type: "list",
    width: "30%",
    style: "min-width: 200px",
  },
  {
    text: "Поточний Залишок",
    value: "currentBalanceHours",
    type: "text",
  },
  {
    text: "Відпрацьовано Годин",
    value: "spentHours",
    type: "text",
  },
  {
    text: "Рекомендована К-сть Годин",
    value: "recommendedHours",
    type: "text",
  },
  {
    text: "Сума до сплати",
    value: "paymentAmount",
    type: "text",
  },
  {
    text: "Рекомендований Пакет",
    value: "recommendedPackage",
    type: "text",
  },
  {
    text: "Сплатити До",
    value: "nextPaymentDate",
    type: "date",
  },
  {
    text: "Відповідальний Менджер",
    value: "manager",
    type: "text",
  },
  {
    text: "Рахунок",
    value: "lastInvoice",
    reference: true,
    componentName: "Invoice",
    getTitle(invoice) {
      return `№ ${invoice.number} від ${invoice.date} | ${invoice.packageAmount}`;
    },
  },
];
